export default "__VITE_ASSET__3a73db2e__"